import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout";

function NotFound() {
  return (
    <Layout>
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-2xl mx-auto px-6 py-12 text-center">
          {/* Error Code */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-slate-900 tracking-tight">404</h1>
            <div className="h-1 w-24 bg-blue-600 mx-auto mt-4"></div>
          </div>

          {/* Error Message */}
          <h2 className="text-3xl font-semibold text-slate-800 mb-4">Page Not Found</h2>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            The page you are looking for might have been removed, had its name changed, or is
            temporarily unavailable.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/"
              className="px-8 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-md hover:shadow-lg"
              style={{ backgroundColor: "rgb(247, 190, 0)" }}
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default NotFound;
